import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'web-design-system-switch',
  imports: [FormsModule],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
})
export class SwitchComponent {
  @Input() public checked = false;
  @Input() public label = '';
  @Input() public disabled = false;

  @Output() public readonly checkedChange = new EventEmitter<boolean>();
}
